module.exports = __webpack_public_path__ + "files/fa663295d1cb74704be2fd1461223449.png";